import axios from 'axios';
import {
	GET_TODAY_SALES_REQUEST,
	GET_TODAY_SALES_SUCCESS,
	GET_TODAY_SALES_FAILURE,
	GET_SALES_REPORT_REQUEST,
	GET_SALES_REPORT_SUCCESS,
	GET_SALES_REPORT_FAILED,
	SET_ALERT,
} from './index';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const getWeeklyySalesReport = () => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		dispatch({ type: GET_SALES_REPORT_REQUEST });

		const response = await axios.get(
			`${BASE_URL}/api/sales/last-seven-days`,
			config
		);
		dispatch({
			type: GET_SALES_REPORT_SUCCESS,
			payload: response.data,
		});
		
	} catch (e) {
		console.log(e);
		dispatch({
			type: SET_ALERT,
			payload: {
				message: 'Failed to fetch sales report',
				status: 'error',
			},
		});
		dispatch({ type: GET_SALES_REPORT_FAILED });
	}
};

export const getTodaysSales = () => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	
	try {
		dispatch({ type: GET_TODAY_SALES_REQUEST });
		const response = await axios.get(BASE_URL+ '/api/sales/today', config);
		console.log(response.data)
		dispatch({ type: GET_TODAY_SALES_SUCCESS, payload: response.data });
		
	} catch (e) {
		console.log(e);
		dispatch({
			type: SET_ALERT,
			payload: { message: "Failed to fetch today's sales", status: 'error' },
		});
		dispatch({ type: GET_TODAY_SALES_FAILURE });
		
	}
};